import * as React from 'react';
import PropTypes from 'prop-types';
import ol_Map from 'ol/Map';
import ol_control_FullScreen from 'ol/control/FullScreen';
import { Util } from '../util';
import Map from '../map';

export class FullScreen extends React.Component {
    constructor(props) {
        super(props);
        this.options = {
            className: undefined,
            label: undefined,
            labelActive: undefined,
            tipLabel: undefined,
            keys: undefined,
            target: undefined,
            source: undefined
        };
        this.events = {
            'change': undefined,
            'propertychange': undefined
        };
    }
    render() { return null; }
    componentDidMount() {
        let options = Util.getOptions(Object['assign'](this.options, this.props));
        this.control = new ol_control_FullScreen(options);
        this.context.mapComp.controls.push(this.control);
        let olEvents = Util.getEvents(this.events, this.props);
        for (let eventName in olEvents) {
            this.control.on(eventName, olEvents[eventName]);
        }
    }
}
FullScreen['contextTypes'] = {
    mapComp: PropTypes.instanceOf(Map),
    map: PropTypes.instanceOf(ol_Map)
};